import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { CategoryFileFragmentDoc } from '../../fragment/generated/CategoryFile';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CategoriesQueryVariables = Types.Exact<{
  crossSubWorkspace?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  subWorkspaceIds?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type CategoriesQuery = { rootCategory?: { edges?: Array<{ __typename: 'FileEdge', node: { id: string, name: string, purpose?: Types.FilePurposeEnum | null, childrenIds?: Array<string> | null, category: Types.FileCategoryEnum, contentCount?: number | null, subWorkspaces?: Array<string> | null } }> | null } | null, categories?: { edges?: Array<{ __typename: 'FileEdge', node: { id: string, name: string, purpose?: Types.FilePurposeEnum | null, childrenIds?: Array<string> | null, category: Types.FileCategoryEnum, contentCount?: number | null, subWorkspaces?: Array<string> | null } }> | null } | null };


export const CategoriesDocument = /*#__PURE__*/ gql`
    query categories($crossSubWorkspace: Boolean, $subWorkspaceIds: [String!]) {
  rootCategory: files(
    filters: {systemGenerated: true, purpose: [LIBRARY_CATEGORY], crossSubWorkspace: $crossSubWorkspace, subWorkspaceIds: $subWorkspaceIds}
    first: -1
  ) {
    edges {
      node {
        ...CategoryFile
      }
      __typename
    }
  }
  categories: files(
    filters: {systemGenerated: false, purpose: [LIBRARY_CATEGORY], crossSubWorkspace: $crossSubWorkspace, subWorkspaceIds: $subWorkspaceIds}
    first: -1
  ) {
    edges {
      node {
        ...CategoryFile
      }
      __typename
    }
  }
}
    ${CategoryFileFragmentDoc}`;

export function useCategoriesQuery(options?: Omit<Urql.UseQueryArgs<CategoriesQueryVariables>, 'query'>) {
  return Urql.useQuery<CategoriesQuery, CategoriesQueryVariables>({ query: CategoriesDocument, ...options });
};